import { render } from "./OptionsTabs.vue?vue&type=template&id=3b7b71df&scoped=true"
import script from "./OptionsTabs.vue?vue&type=script&lang=js"
export * from "./OptionsTabs.vue?vue&type=script&lang=js"

import "./OptionsTabs.vue?vue&type=style&index=0&id=3b7b71df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7b71df"]])

export default __exports__